import React, { useState } from "react";
import "../App.css";
import { DxCheckbox } from "genesys-react-components";

export function DivisionFilter({
  divisions,
  checkedDivisions,
  setTempCheckedDivisions, // Pass the setter for temporary state from LeftPanel
}) {
  const handleCheckboxChange = (checked, divisionId) => {
    setTempCheckedDivisions((prev) =>
      checked
        ? [...prev, divisionId]
        : prev.filter((item) => item !== divisionId)
    );
  };

  return (
    <div>
      {divisions ? (
        <>
          <p>Division Filter:</p>
          {divisions.map((division) => (
            <DxCheckbox
              key={division.id}
              label={division.name}
              value={division.id}
              initialValue={checkedDivisions.includes(division.id)}
              name={division.name}
              className="clazzy-checkbox m-0"
              onCheckChanged={(checked) =>
                handleCheckboxChange(checked, division.id)
              }
            />
          ))}
        </>
      ) : (
        <span>No Divisions</span>
      )}
    </div>
  );
}